<feature-card itineraryCard toggleFavorite="itineraries" [id]="itinerary.id" [itinerary]="itinerary" *ngFor="let itinerary of service.viewDisplayItems$ | async" [@opacityFade]>

  <img featureCardImage [lazyLoad]="itinerary.coverImage.imgUrl" defaultImage="assets/img/blank.webp" errorImage="assets/img/blank.webp" [alt]="itinerary.pageTitle">
  <feature-card-date>{{ itinerary.numDays }}</feature-card-date>
  <img featureCardItineraryImage [lazyLoad]="itinerary?.author?.authorProfPic!" defaultImage="assets/img/blank.webp" errorImage="assets/img/blank.webp" [alt]="itinerary.pageTitle">
  <feature-card-itinerary-title>{{ itinerary.title }}</feature-card-itinerary-title>
  <feature-card-itinerary-snippet [class.no-content]="!itinerary.snippet">{{ itinerary.snippet }}</feature-card-itinerary-snippet>

</feature-card>

<ng-container *ngIf="!(service.itineraries$ | async)">

  <ngx-skeleton-loader class="search-result-card" count="1" appearance="line" *ngFor="let _ of skeletons$ | async;" [@opacityFadeIn]>
  </ngx-skeleton-loader>

</ng-container>

<ng-container *ngIf="(service.itineraries$ | async)?.length === 0">
  <p class="ht-no-results" translate="search-page.no-results-found"></p>
</ng-container>
